import react, { useEffect, useRef, useState } from 'react'
import { useNavigate } from "react-router"
import { useUser } from "../Services"
import { User_Data } from '../Services/Agrisys_GqlDataCaller/UserCalls/GQLCalls/getCalls'
import { useTranslation } from "react-i18next"
import { Button, Modal, InputFieldList, InputFieldList_PropHandle } from "../Components"
import { frames, glyphs, css, fonts, colors } from "../Styles"
import { ButtonTypes } from '../Definitions'

interface UserInformations_Props {
  isLoginFlow?: boolean
}

export default function UserInformations() {
  const {t} = useTranslation()
  const navigator = useNavigate()

  const inputRef=useRef<InputFieldList_PropHandle>(null)
  const { userToken, getUserData, userData, updateUserData } = useUser()
  const [userDatas, setUserData] = useState<User_Data | undefined>(undefined);
  const [message, setMessage] = useState<string|null>(null)

  useEffect(() => {
    if (userToken) getUserData(userToken)
  },[])

  useEffect(() => {
    setUserData(userData);
  },[userToken, userData, getUserData])

  useEffect(()=> {
    if (userDatas !== undefined) {
      inputRef.current?.refs.current[0].setContext(userDatas.firstname)
      inputRef.current?.refs.current[1].setContext(userDatas.lastname)
      inputRef.current?.refs.current[2].setContext(userDatas.phone)
      inputRef.current?.refs.current[3].setContext(userDatas.email)
      inputRef.current?.refs.current[4].setContext(userDatas.address)
      inputRef.current?.refs.current[5].setContext(userDatas.country)
    }
  }, [userDatas, inputRef.current])

  const UpdateData = () => {
    const firstname = inputRef.current?.refs.current[0].context;
    const lastname = inputRef.current?.refs.current[1].context;
    const phone = inputRef.current?.refs.current[2].context;
    const email = inputRef.current?.refs.current[3].context;
    const address = inputRef.current?.refs.current[4].context;
    const country = inputRef.current?.refs.current[5].context;
  
    if (!firstname) {
      inputRef.current?.refs.current[0].setError();
      inputRef.current?.refs.current[0].focus();
      setMessage("Saving failed");
    } else if (!lastname) {
      inputRef.current?.refs.current[1].setError();
      inputRef.current?.refs.current[1].focus();
      setMessage("Saving failed");
    } else if (!phone) {
      inputRef.current?.refs.current[2].setError();
      inputRef.current?.refs.current[2].focus();
      setMessage("Saving failed");
    } else if (!email) {
      inputRef.current?.refs.current[3].setError();
      inputRef.current?.refs.current[3].focus();
      setMessage("Saving failed");
    } else {
      var NewData = {
        firstname: inputRef.current?.refs.current[0].context,
        lastname: inputRef.current?.refs.current[1].context,
        phone: inputRef.current?.refs.current[2].context,
        email: inputRef.current?.refs.current[3].context,
        address: inputRef.current?.refs.current[4].context,
        country: inputRef.current?.refs.current[5].context
      } as User_Data;
      updateUserData(NewData.firstname, NewData.lastname, NewData.phone, NewData.email, NewData.address, NewData.country, userToken);
      setMessage("Saved");
    }
    setTimeout(() => {
      setMessage(null);
    }, 2000);
  };

  console.log("data:", userData);
  return (
    <frames.DecorBg>
      <Modal
        modalHeader={t("user.userInformations")}
        overrides={{ 
          isPrimaryComponent: true,
        }}
        onGoBack={() => navigator(-1)}
      > 
        <div style={{position: "relative", zIndex: "999"}}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px"}}>
            {/* TODO: Insert User ID based on the session user */}
            <InputFieldList ref={inputRef}
              startEnhancers={[glyphs.User({size: "25px"}), glyphs.User({size: "25px"}), glyphs.Phone({size: "25px"}), glyphs.Mail({size: "25px"}), glyphs.Address({size: "25px"}), glyphs.Country({size: "25px"})]}
              placeholder={[t("user.firstName")+"...", t("user.lastName")+"...", t("user.phone")+"...", t("user.email")+"...", "Address...", "Country..." ]}
              inputTypes={["text", "text", "tel", "email", "text", "text"]}
              isRequired={[true, true, true, true, false, false]}
              listStyle="vertical"
              listGap='10px'
            />
            <Button content={t("buttons.saveBtn")} onClick={() => UpdateData()}
              buttonType={ButtonTypes.primaryButton}
              overrides={{
                baseButton: {...css.button_FitContent}
              }}
            />
            {message && <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary, position: "absolute", zIndex: "9999", top: "305px"}}>{message}</p>}
          </div>
        </div>
      </Modal>
    </frames.DecorBg>
  );
}